import { createFormHook } from "@tanstack/react-form";
import { FormSubmitButton } from "~/components/form-fields/FormSubmitButton";
import { ValidatedCheckbox } from "~/components/form-fields/ValidatedCheckbox";
import { ValidatedColorPicker } from "~/components/form-fields/ValidatedColorPicker";
import { ValidatedCombobox } from "~/components/form-fields/ValidatedCombobox";
import { ValidatedDatePicker } from "~/components/form-fields/ValidatedDatePicker";
import { ValidatedFileUpload } from "~/components/form-fields/ValidatedFileUpload";
import { ValidatedInput } from "~/components/form-fields/ValidatedInput";
import { ValidatedPhoneInput } from "~/components/form-fields/ValidatedPhoneInput";
import { ValidatedRadioGroup } from "~/components/form-fields/ValidatedRadioGroup";
import { ValidatedSelect } from "~/components/form-fields/ValidatedSelect";
import { ValidatedTextarea } from "~/components/form-fields/ValidatedTextarea";
import { fieldContext, formContext } from "./form-context";

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    ValidatedInput,
    ValidatedSelect,
    ValidatedCheckbox,
    ValidatedDatePicker,
    ValidatedCombobox,
    ValidatedPhoneInput,
    ValidatedFileUpload,
    ValidatedColorPicker,
    ValidatedTextarea,
    ValidatedRadioGroup,
  },
  formComponents: {
    FormSubmitButton,
  },
});
